import type { FilterAiOptions_Response } from '@zendesk/zqa-services/filters'
import { api } from '@/api'
import { session } from '@/composables/useSession'

export type AiFilterStatus = 'fulfilled' | 'partial' | 'unmet'

export interface AiFilterOptionsResponse extends Omit<FilterAiOptions_Response, 'status'> {
  status: AiFilterStatus
}

export function getAiFilterOptions(prompt: string, signal?: AbortSignal): Promise<AiFilterOptionsResponse> {
  return api
    .post('filter/ai-options', {
      headers: { 'X-Klaus-Workspace': session.workspace.id.toString() },
      json: { prompt },
      signal,
    })
    .json()
}
